import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ROUTES } from './api-routes';
import { MarketDataElectricity, MarketDataGas } from '../interfaces/market-data-interfaces';
import { DEFAULT_JSON_HEADERS } from './headers.config';

@Injectable({
  providedIn: 'root'
})
export class MarketDataService {
  constructor(private http: HttpClient) { }

  getElectricityMarketData(): Observable<any> {
    return this.http.get<MarketDataElectricity>(
      API_ROUTES.MARKET_DATA.ELECTRICITY
    );
  }

  createElectricityMarketData(marketData: MarketDataElectricity): Observable<any> {
    const payload = JSON.stringify(marketData);

    return this.http.put<MarketDataElectricity>(
      API_ROUTES.MARKET_DATA.ELECTRICITY,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  editElectricityMarketData(marketData: MarketDataElectricity): Observable<any> {
    const payload = JSON.stringify(marketData);

    return this.http.post<MarketDataElectricity>(
      `${API_ROUTES.MARKET_DATA.ELECTRICITY_ID}${marketData.id}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  getGasMarketData(): Observable<any> {
    return this.http.get<MarketDataGas>(
      API_ROUTES.MARKET_DATA.GAS
    );
  }

  createGasMarketData(marketData: MarketDataGas): Observable<any> {
    const payload = JSON.stringify(marketData);

    return this.http.put<MarketDataGas>(
      API_ROUTES.MARKET_DATA.GAS,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  editGasMarketData(marketData: MarketDataGas): Observable<any> {
    const payload = JSON.stringify(marketData);

    return this.http.post<MarketDataGas>(
      `${API_ROUTES.MARKET_DATA.GAS_ID}${marketData.id}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }
}
